module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Justice-League.720f55f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Justice-League.jpg
// module id = aZli
// module chunks = 0